import React from 'react';
import {withRouter, Link as RouterLink} from 'react-router-dom';
import * as helpers from '../lib/helpers';
import * as api from '../lib/api';
import _ from 'lodash';
import store,{actions} from '../store';

class BlueprintList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      initializing: true,
    };

    this.isSubmitMode = this.isSubmitMode.bind(this);
    this.createActionButton = this.createActionButton.bind(this);
  }

  async componentDidMount() {
    this.setState({
      initializing: false,
      blueprints: await store.dispatch(actions.blueprints.fetchAll()),
    });
  }

  preventDefault(e){
    e.preventDefault();
  }

  createActionButton(blueprint) {
    if (this.isSubmitMode()) {
      return (

          <RouterLink to={`/blueprints/submit/${blueprint.groupId}/${blueprint.blueprintId}`}
                      className="btn btn-purple"
                      key="review-action"
                      onClick={this.preventDefault}
          >
            <span>Submit Now</span>
          </RouterLink>
      );
    }
    return (
        <RouterLink to={`/blueprints/review/${blueprint.groupId}/${blueprint.blueprintId}`}
                    className="re-view"
                    key="review-action"
                    onClick={this.preventDefault}
        >
          <img src="/img/re-view.png" alt=""/>
          <span>Review Blueprint</span>
        </RouterLink>
    )
  }

  redirectForSubmitOrReview(blueprint) {
    let mode = this.isSubmitMode() ? 'submit' : 'review';
    this.props.history.push(
        `/blueprints/${mode}/${blueprint.groupId}/${blueprint.blueprintId}`);
  }

  isSubmitMode() {
    return this.props.mode !== 'review';
  }

  renderListItem(blueprint) {
    return (
        <div className="discussions-row"
             key={`${blueprint.groupId}_${blueprint.blueprintId}`}
             onClick={() => this.redirectForSubmitOrReview(blueprint)}
        >
          <div className="row align-items-center">
            <div
                 className="col-md-4 col-sm-4 col-12 text-md-left text-sm-left text-center"
                 style={{cursor:'pointer'}}>
              <h3>{blueprint.name}</h3>
            </div>
            <div className="col-md-4 col-sm-4 col-12 text-center">
                        <span className="Created-time">
                            {'Created: ' +
                            new Date(blueprint.createdAt).toLocaleString()}
                        </span>
            </div>
            <div
                className="col-md-4 col-sm-4 col-12 text-md-right text-sm-right text-center">
              {this.createActionButton(blueprint)}
            </div>
          </div>
        </div>
    );
  }

  render() {
    return this.state.initializing ? helpers.showPanelLoading() : (
        <div className="BlueprintList">
          <div className="box-panel">
            <div className="box-panel--head">
              <div className="title">
                <h2>{this.isSubmitMode() ?
                    'Submit Blueprint' :
                    'Review Blueprint'}</h2>
              </div>
            </div>
            <div className="progreesbtm"
                 style={{'height': 'auto', 'padding': 0}}>
              {
                (() => {
                  return this.state.blueprints.length === 0 ?
                      (
                          <div className="discussions-row">
                            <div
                                className="row align-items-center d-flex justify-content-center">
                              <i>No Blueprints</i>
                            </div>
                          </div>
                      ) :
                      _.reduce(this.state.blueprints,
                          (container, blueprint) => {
                            container.push(this.renderListItem(blueprint));
                            return container;
                          }, []);
                })()
              }
            </div>
          </div>
        </div>
    );
  }
}

export default withRouter(BlueprintList);


// WEBPACK FOOTER //
// ./src/containers/BlueprintList.js